export default __webpack_public_path__ + "static/Sizzle_New_Desktop-6a37614465c2bd6638f08bb46e8c5ee0.webm";